<template>
  <div class="bg-white pa-8 d-flex flex-column">
    <div class="d-flex align-center justify-space-between">
      <div class="d-flex align-center">
        <h4 class="title mr-2">App Experience:</h4>
        <drop-down v-model="appExperience" :items="['General', 'Custom']" />
      </div>
      <div>
        <drop-down v-model="years" :items="['Last 7 years', 'Last 5 years']" />
      </div>
    </div>
    <div class="flex">
      <canvas id="location-chart"></canvas>
    </div>
  </div>
</template>

<script>
import DropDown from "@/components/custom/DropDown.vue";
export default {
  components: {
    DropDown
  },
  mounted() {
    let ctx = document.getElementById("location-chart").getContext("2d");
    let myChart = new Chart(ctx, {
      type: "horizontalBar",
      data: {
        labels: ["2020", "2019", "2018", "2017", "2016", "2015", "2014"],
        datasets: [
          {
            label: "Employee",
            data: [
              800000,
              3500000,
              3100000,
              3200000,
              4500000,
              2800000,
              3500000
            ],
            barThickness: 20,
            backgroundColor: [
              "#FC7D58",
              "#F2C94C",
              "#38C976",
              "#FFE24D",
              "#EB5757",
              "#38C976",
              "#38C976"
            ]
          },
          {
            label: "Engineer",
            backgroundColor: "#FEE4DD",
            data: [
              1000000,
              5700000,
              4300000,
              4400000,
              6200000,
              3400000,
              5800000
            ],
            barThickness: 20,
            backgroundColor: [
              "#FEE4DD",
              "#FCF3DA",
              "#D6F3E3",
              "#FEF8DB",
              "#FADDDD",
              "#D6F3E3",
              "#D6F3E3"
            ]
          }
        ]
      },
      options: {
        legend: {
          display: false
        },
        tooltips: {
          displayColors: true,
          callbacks: {
            mode: "x"
          }
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: {
                offsetGridLines: false,
                borderDash: [5, 8]
              },
              ticks: {
                fontColor: "#C0C7CE",
                callback: function(value, index, values) {
                  return (
                    "$" +
                    (Math.abs(Number(value)) >= 1.0e9
                      ? Math.abs(Number(value)) / 1.0e9 + "B"
                      : // Six Zeroes for Millions
                      Math.abs(Number(value)) >= 1.0e6
                      ? Math.abs(Number(value)) / 1.0e6 + "M"
                      : // Three Zeroes for Thousands
                      Math.abs(Number(value)) >= 1.0e3
                      ? Math.abs(Number(value)) / 1.0e3 + "K"
                      : Math.abs(Number(value)))
                  );
                }
              }
            }
          ],
          yAxes: [
            {
              stacked: true,
              gridLines: {
                display: false
              },
              ticks: {
                fontColor: "#C0C7CE"
              }
            }
          ]
        },
        maintainAspectRatio: false
      }
    });
  },
  data() {
    return {
      appExperience: "General",
      years: "Last 7 years",
      data: {
        USA: 90,
        China: 70,
        Russia: 40,
        Germany: 30,
        "United Kingdom": 35,
        Turkey: 22
      }
    };
  }
};
</script>

<style>
.chart-card {
  border-radius: 3px;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  box-shadow: none !important;
  background-color: transparent;
}
.title {
  font-family: Gotham-Medium;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  color: #3d4857;
}
</style>
